import {
	Container,
	ContainerPadding,
	Text,
	TokenTextAppearance,
	TextAlignment,
} from '@volkswagen-onehub/components-core';
import React from 'react';

export const GTIDayAgotado: React.FC = () => {
	return (
		<Container
			padding={{
				right: ContainerPadding.dynamic0100,
				bottom: ContainerPadding.dynamic0100,
				left: ContainerPadding.dynamic0100,
			}}
			horizontalAlign={'center'}
			wrap={'always'}
		>
			<Container wrap={'always'}>
				<Text appearance={TokenTextAppearance.headline300} textAlign={TextAlignment.center}>
					¡Lo sentimos!
				</Text>
				<Text appearance={TokenTextAppearance.headline300} textAlign={TextAlignment.center}>
					{'El Libro de diseño de Volkswagen\u0020'}
					<Text bold>Se acaban de agotar las 100 entradas dobles gratuitas.</Text>
				</Text>

				<Container
					wrap={'always'}
					padding={{
						top: ContainerPadding.dynamic0200,
						bottom: ContainerPadding.dynamic0100,
					}}
					verticalAlign={'center'}
					horizontalAlign={'center'}
				>
					<Text appearance={TokenTextAppearance.copy200} textAlign={TextAlignment.center}>
						¡Pero aún puedes unirte a la celebración de medio siglo de GTI! Consigue tu entrada desde la web del evento
						y nos vemos el sábado 27 de julio en el Circuit de Barcelona-Catalunya.
					</Text>
				</Container>
			</Container>
		</Container>
	);
};
